import {
  Component,
  OnInit,
  ViewChild,
  Input,
  Output,
  EventEmitter,
} from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { CommonService } from "src/app/core/services/common.service";
import { BdspStaticService } from "src/app/core/services/bdsp/bdsp-static.service";
import { DefaultTargeting } from "src/app/models/campaigns";
import { CountryObject } from "src/app/models/bdsp/bdsp-line-item";
import { TrgtEditAction, trgtOperationOptions } from "src/app/models/common";

@Component({
  selector: "app-bdsp-geo-targeting",
  templateUrl: "./bdsp-geo-targeting.component.html",
  styleUrls: ["./bdsp-geo-targeting.component.scss"],
})
export class BdspGeoTargetingComponent implements OnInit {
  @Output() stepChange = new EventEmitter<any>();
  @Input() stepInput: any;

  dataSourceGeo: MatTableDataSource<any>;
  @ViewChild("geoPaginator") paginatorGeo: MatPaginator;
  @ViewChild("geoSort") sortGeo: MatSort;

  def_li_targeting: DefaultTargeting;

  geoPrurals = {
    country: "countries",
    city: "cities",
    region: "regions",
    metros: "metros",
  };

  search_params = {};
  isEdit: boolean = false;
  geoFilter;

  selectedGeoTab: "country" | "city" | "region" = "country";
  selectedGeoChip: "geo" | "dma" | "postal_codes" | "custom_location" = "geo";
  displayColumnGeo: Array<any> = [];
  country_action: "include" | "exclude" | "" = "";
  region_action: "include" | "exclude" | "" = "";
  city_action: "include" | "exclude" | "" = "";
  zip_action: "include" | "exclude" | "" = "include";

  allGeo: Array<any> = [];
  geoSearchTerm: string;
  geoObject: Array<CountryObject> = [];

  dataSourceMetro: MatTableDataSource<any>;
  @ViewChild("metroPaginator") paginatorMetro: MatPaginator;
  @ViewChild("metroSort") sortMetro: MatSort;

  allMetro: Array<any> = [];
  showMetroCode: boolean = false;
  displayColumnMetro: string[] = ["checkbox", "name", "key"];
  selectedMetro: Array<any> = [];
  metro_action: "include" | "exclude" | "" = "";
  dmaPageLength: number;
  pageLength;
  customLocs: Array<any> = [];

  selectedCountryIDForPostalCodes: number;
  allCountriesForPostalCodes = [];
  ctryToTarget: Array<any> = [];
  inputZipCodes: string;
  selectedZip: Array<any> = [];

  bulkEditTrgtAct: TrgtEditAction;
  trgtOperations: Array<any> = [];
  selectedTrgts: Array<any> = [];

  constructor(
    private bdspStaticService: BdspStaticService,
    private commonService: CommonService
  ) {
    commonService.getIvtData.subscribe((res) => {
      this.customLocs = res.list;
      if (this.stepInput.isBulkEdit) {
        this.bulkEditTrgtAct[`${res.type}`] = res.bulkEditAction;
      }
    });
  }

  ngOnInit(): void {
    this.isEdit = this.stepInput.isEdit;
    this.geoObject = this.stepInput.geoObject;
    this.customLocs = this.stepInput.customLocs;
    if (this.stepInput.isDlvMod) {
      this.selectedTrgts = this.stepInput.selectedTrgts;
      this.country_action = "include";
      this.city_action = "include";
      this.region_action = "include";
      if (this.selectedTrgts.includes("country")) {
        this.getGeoTab("country");
      } else if (this.selectedTrgts.includes("region")) {
        this.selectedGeoTab = "region";
        this.getGeoTab("region");
      } else if (this.selectedTrgts.includes("city")) {
        this.selectedGeoTab = "city";
        this.getGeoTab("city");
      }
    } else {
      if (this.stepInput.isBulkEdit) {
        this.trgtOperations = JSON.parse(JSON.stringify(trgtOperationOptions));
        this.bulkEditTrgtAct = this.stepInput.bulkEditTrgtAct;
      }
      this.getGeoTab("country");
      this.checkForUS();
    }
  }

  checkForUS() {
    if (this.geoObject.length == 0) {
      this.showMetroCode = false;
      return;
    }
    let usState = this.geoObject.filter((ele) => ele.country.id == "USA");
    if (usState.length != 0) this.showMetroCode = true;
    else this.showMetroCode = false;
  }

  setGeoData() {
    if (!this.stepInput.isDlvMod) {
      this.country_action = this.stepInput.country_action;
      this.region_action = this.stepInput.region_action;
      this.city_action = this.stepInput.city_action;
      this.metro_action = this.stepInput.metro_action;
      this.selectedMetro = this.stepInput.selectedMetro;
    }
    this.geoObject = this.stepInput.geoObject;
    if (!this.stepInput.isDlvMod && this.stepInput.selectedZip.length > 0) {
      this.selectedZip = this.stepInput.selectedZip;
      this.zip_action = this.stepInput.zip_action;
    }
    this.checkForUS();
    this.proceed();
  }

  searchGeoData(event) {
    let filter = event.target.value.toLowerCase();
    let params = {
      fields: "name",
      name: filter,
    };
    this.getGeoData(this.selectedGeoTab, 0, 100, false, params);
  }

  regionFilters(params = {}) {
    let country_ids = [];
    if (this.geoFilter) {
      country_ids.push(this.geoFilter.country_code_3);
    } else {
      this.geoObject.forEach((c) => {
        if (c.country_included) country_ids.push(c.country.id);
      });
    }
    if (country_ids.length > 0) {
      if (params["fields"]) {
        params["fields"] += ",country_code_3";
      } else {
        params["fields"] = "country_code_3";
      }
      params["country_code_3"] = country_ids.join(",");
      if (this.country_action == "exclude" && !this.geoFilter) {
        params["excludes"] = "country_code_3";
      }
    }
    return params;
  }

  cityFilters(params = {}) {
    let region_ids = [];
    let country_ids = [];
    let region_filter_added: boolean = false;
    if (this.geoFilter && this.geoFilter.country_name) {
      region_ids.push(this.geoFilter.region_code);
      region_filter_added = true;
      country_ids.push(this.geoFilter.country_code_3);
    } else if (this.geoFilter) {
      country_ids.push(this.geoFilter.country_code_3);
    } else {
      this.geoObject.forEach((country) => {
        if (country.country_included) {
          country_ids.push(country.country.id);
        }
        region_ids = region_ids.concat(
          country.regions.filter((ele) => ele.region_included).map((ele) => ele.region.id.split("/")[1])
        );
      });
    }
    if (
      region_ids.length > 0 &&
      (this.country_action == "include" ||
        this.region_action == "exclude" ||
        region_filter_added)
    ) {
      if (params["fields"]) {
        params["fields"] += ",region_code";
      } else {
        params["fields"] = "region_code";
      }
      params["region_code"] = region_ids.join(",");
      if (
        this.region_action == "exclude" &&
        !(this.geoFilter && this.geoFilter.country_name)
      ) {
        params["excludes"] = "region_code";
      }
    }
    if (country_ids.length > 0) {
      if (params["fields"]) {
        params["fields"] += ",country_code_3";
      } else {
        params["fields"] = "country_code_3";
      }
      params["country_code_3"] = country_ids.join(",");
      if (this.country_action == "exclude" && !this.geoFilter) {
        if (params["excludes"]) {
          params["excludes"] += ",country_code_3";
        } else {
          params["excludes"] = "country_code_3";
        }
      }
    }

    return params;
  }

  getGeoData(
    type: "country" | "region" | "city",
    start_element?,
    num_elements?,
    merge: boolean = false,
    params = {}
  ) {
    this.setGeoData();
    if (type == "region") {
      params = this.regionFilters(params);
    } else if (type == "city") {
      params = this.cityFilters(params);
    } else {
      params["columns"] = "name,country_code_3";
    }
    params = { ...params, ...this.search_params, ...this.stepInput.globalParams };
    this.bdspStaticService
      .getStaticData(type, start_element, num_elements, params)
      .subscribe(
        (res) => {
          let geo: Array<any> = [];
          if (type == "country") {
            geo = res.countries;
            if (!params['field'] && this.ctryToTarget.length == 0 ){
              this.ctryToTarget = res.countries.map((country) => country.name)
            }
          } else if (type == "region") {
            geo = res.region;
          } else if (type == "city") {
            geo = res.cities;
          } else {
            geo = res.metros;
          }
          if (merge) {
            this.allGeo = this.allGeo.concat(
              geo.map((e) => ({
                ...e,
                selected: false,
              }))
            );
            if (this.selectedGeoChip != "postal_codes") {
              this.pageLength = res.count;
              this.dataSourceGeo = new MatTableDataSource(this.allGeo);
              this.dataSourceGeo.paginator = this.paginatorGeo;
              this.dataSourceGeo.sort = this.sortGeo;
              this.dataSourceGeo._updatePaginator(this.pageLength);
            }
          } else {
            this.allGeo = geo.map((e) => ({
              ...e,
              selected: false,
            }));
            if (this.selectedGeoChip != "postal_codes") {
              this.pageLength = res.count;
              this.dataSourceGeo = new MatTableDataSource(this.allGeo);
              this.dataSourceGeo.paginator = this.paginatorGeo;
              this.dataSourceGeo.sort = this.sortGeo;
              this.dataSourceGeo._updatePaginator(this.pageLength);
              this.dataSourceGeo.paginator.firstPage();
            }
          }
        },
        () => {},
        () => {}
      );
  }

  getGeoTab(tab: "country" | "region" | "city") {
    this.selectedGeoTab = tab;
    this.search_params = {};
    this.trgtOperations = this.trgtOperations.slice(0,2);
    if (this.selectedGeoTab == "country") {
      this.displayColumnGeo = ["checkbox", "name"];
      this.geoFilter = null;
      this.geoSearchTerm = null;
    } else {
      if (this.selectedGeoTab == "region") {
        this.displayColumnGeo = ["checkbox", "name", "country_name"];
        if (this.geoFilter && this.geoFilter.country_code_2) {
          this.geoFilter = null;
        }
        this.geoSearchTerm = null;
      }
      if (this.selectedGeoTab == "city") {
        this.displayColumnGeo = [
          "checkbox",
          "name",
          "region_name",
          "country_name",
        ];
        this.geoSearchTerm = null;
      }
    }
    this.getGeoData(tab);
  }

  getAllDma(params = {}, start_element?, num_elements?, merge = false) {
    params = { ...params, ...this.stepInput.globalParams };
    this.bdspStaticService
      .getStaticData("metros", start_element, num_elements, params)
      .subscribe((res) => {
        this.allMetro = res.metros.map((e) => ({
          ...e,
          selected: false,
        }));
        if (merge) {
          this.allGeo = this.allGeo.concat(this.allMetro);
          this.dataSourceMetro = new MatTableDataSource(this.allGeo);
          this.dataSourceMetro.paginator = this.paginatorMetro;
          this.dataSourceMetro.sort = this.sortMetro;
          this.dataSourceMetro._updatePaginator(this.dmaPageLength);
        } else {
          this.dmaPageLength = res.count;
          this.dataSourceMetro = new MatTableDataSource(this.allMetro);
          this.dataSourceMetro.paginator = this.paginatorMetro;
          this.dataSourceMetro.sort = this.sortMetro;
          this.dataSourceMetro._updatePaginator(this.dmaPageLength);
        }
      });
  }

  getGeoChip(value: "geo" | "dma" | "postal_codes") {
    this.selectedGeoChip = value;
    if (value == "dma") {
      this.getAllDma();
    } else if (value == "geo") {
      this.getGeoTab("country");
    }

    if(value == "postal_codes"){
      this.trgtOperations = JSON.parse(JSON.stringify(trgtOperationOptions));
    }
  }

  isIncluded(action_item) {
    return action_item == "" || action_item == "include";
  }

  isExcluded(action_item) {
    return action_item == "" || action_item == "exclude";
  }

  getFilteredGeo(geo) {
    let allowFilter: boolean = true;
    if (this.selectedGeoTab == "city") return;
    if (geo && geo.country_code_3) {
      this.geoObject.forEach((c) => {
        c.regions.forEach((r) => {
          if (r.region.id == geo.id && this.region_action == "exclude")
            allowFilter = false;
        });
      });
    } else {
      this.geoObject.forEach((c) => {
        if (c.country.id == geo.id && this.country_action == "exclude")
          allowFilter = false;
      });
    }
    if (allowFilter) {
      this.geoFilter = geo;
      if (this.selectedGeoTab == "country") {
        delete this.search_params["search_term"];
        this.getGeoTab("region");
      } else if (this.selectedGeoTab == "region") {
        delete this.search_params["search_term"];
        this.getGeoTab("city");
      }
    }
  }

  isIncludeGeo() {
    if (this.selectedGeoTab == "country") {
      return this.isIncluded(this.country_action);
    } else if (this.selectedGeoTab == "region") {
      let r_action = false;
      if (
        this.geoFilter &&
        !this.geoFilter.name &&
        this.geoObject.length > 0 &&
        this.country_action == "include"
      ) {
        this.geoObject.forEach((ele) => {
          if (ele.country.id == this.geoFilter.id && ele.country_included) {
            r_action = true;
          }
        });
      } else {
        r_action = this.isIncluded(this.region_action);
      }
      return r_action;
    } else if (this.selectedGeoTab == "city") {
      let c_action = false;
      if (
        this.geoFilter &&
        this.geoFilter.name &&
        this.geoObject.length > 0 &&
        this.country_action == "include"
      ) {
        this.geoObject.forEach((c) => {
          if (
            c.country.id == this.geoFilter.country_code_3 &&
            c.country_included
          ) {
            c_action = true;
          }
        });
      } else if (
        this.geoFilter &&
        !this.geoFilter.name &&
        this.geoObject.length > 0 &&
        this.country_action == "include"
      ) {
        this.geoObject.forEach((ele) => {
          if (
            ele.country.id == this.geoFilter.country_code_3 &&
            ele.country_included
          ) {
            c_action = true;
          }
        });
      } else {
        c_action = this.isIncluded(this.city_action);
      }
      return c_action;
    }
  }

  isExcludeGeo() {
    if (this.selectedGeoTab == "country") {
      return this.isExcluded(this.country_action);
    } else if (this.selectedGeoTab == "region") {
      let r_action = false;
      if (
        this.geoFilter &&
        !this.geoFilter.name &&
        this.geoObject.length > 0 &&
        this.country_action == "include"
      ) {
        if (this.geoFilter.length == 0) r_action = true;
        this.geoObject.forEach((ele) => {
          if (ele.country.id == this.geoFilter.id && ele.country_included) {
            r_action = true;
          }
        });
      } else {
        r_action = this.isExcluded(this.region_action);
      }
      return r_action;
    } else if (this.selectedGeoTab == "city") {
      let c_action = false;
      if (
        this.geoFilter &&
        this.geoFilter.name &&
        this.geoObject.length > 0 &&
        this.country_action == "include"
      ) {
        this.geoObject.forEach((c) => {
          if (
            c.country.id == this.geoFilter.country_code_3 &&
            c.country_included
          ) {
            c_action = true;
          }
          // c.regions.forEach(reg => {
          //   if (reg.region.id == this.geoFilter.id && reg.region_included) {
          //     c_action = true
          //   }
          // })
        });
      } else if (
        this.geoFilter &&
        !this.geoFilter.name &&
        this.geoObject.length > 0 &&
        this.country_action == "include"
      ) {
        this.geoObject.forEach((ele) => {
          if (
            ele.country.id == this.geoFilter.country_code_3 &&
            ele.country_included
          ) {
            c_action = true;
          }
        });
      } else {
        c_action = this.isExcluded(this.city_action);
      }
      return c_action;
    }
  }

  handlePageEvent(event: PageEvent) {
    this.pageLength = this.dmaPageLength = event.length;
    let requested_page = event.pageSize * (event.pageIndex + 1);
    let num_elements = 100;
    if (requested_page > 300) {
      let start_element = this.allGeo.length;
      if (this.selectedGeoChip == "dma") {
        this.getAllDma(this.search_params, start_element, num_elements, true);
      } else {
        this.getGeoData(
          this.selectedGeoTab,
          start_element,
          num_elements,
          true,
          this.search_params
        );
      }
    }
  }

  removeGeoFilter() {
    this.geoFilter = null;
    this.getGeoTab("country");
  }

  addGeo(row, action: "include" | "exclude", event) {
    if (this.stepInput.isDlvMod) {
      event.preventDefault();
    }
    if (
      this.selectedGeoTab == "country" &&
      (this.country_action == "" || this.country_action == action)
    ) {
      let country_obj = this.geoObject.filter(
        (ele) => ele.country.id == row.country_code_3
      )[0];
      if (!country_obj) {
        // deliver modifiers code starts here

        if (this.stepInput.isDlvMod) {
          const isCountryIncluded = this.geoObject.some(
            (geo) => geo.country_included == true
          );

          // if country is already included.
          if (isCountryIncluded) {
            let added = false; // Flag to track if a new object has been added.

            for (let i = 0; i < this.geoObject.length; i++) {
              let geo = this.geoObject[i];

              // if the new country id to be added is different
              if (
                geo.country_included &&
                geo.country.id !== row.country_code_3
              ) {
                // Replace the existing country ID with the new one if there are no regions for the country.
                if (geo.regions.length === 0) {
                  geo.country = { id: row.country_code_3, name: row.name };
                  added = true; // If we've modified an object, we can set added flag
                  break; // Exit the loop since we've handled this case
                } else {
                  // Set country_included to false if there are regions
                  geo.country_included = false;
                }
              }
            }

            // If no object was modified, add a new one
            if (!added) {
              this.geoObject.push({
                country: { id: row.country_code_3, name: row.name },
                country_included: true,
                regions: [],
              });
            }
          }
          // If country is not included, directly push a new object
          else {
            this.geoObject.push({
              country: { id: row.country_code_3, name: row.name },
              country_included: true,
              regions: [],
            });
          }
        }
        //deliver modifiers code starts here

        // LI-geo targeting code
        else {
          this.geoObject.push({
            country: { id: row.country_code_3, name: row.name },
            country_included: true,
            regions: [],
          });
        }

        this.country_action = action;
      } else {
        if (action == "exclude") {
          let dont_allow_save: boolean = false;
          country_obj.regions.forEach((reg) => {
            if (reg.region_included && this.region_action == "include") {
              dont_allow_save = true;
            } else if (reg.cities.length > 0 && this.city_action == "include") {
              dont_allow_save = true;
            }
          });
          if (!dont_allow_save) {
            country_obj.country_included = true;
            this.country_action = action;
          }
        } else {
          // for deliver modifiers starts
          if (this.stepInput.isDlvMod) {
            // Remove the existing country object if it has no regions.
            this.geoObject = this.geoObject.filter((geo) => {
              if (geo.country_included) {
                if (geo.regions.length == 0) {
                  return false;
                } else {
                  geo.country_included = false;
                  return true;
                }
              }
              return true;
            });
            country_obj.country_included = true;
          }
          // for deliver modifiers ends.

          // LI - Geo Targeting
          else {
            country_obj.country_included = true;
          }
          this.country_action = action;
        }
      }
    } else if (
      this.selectedGeoTab == "region" &&
      (this.region_action == "" || this.region_action == action)
    ) {
      let region_obj = {
        region: { id: row.key, name: row.name },
        region_included: true,
        cities: [],
      };
      let country_obj = this.geoObject.filter(
        (ele) => ele.country.id == row.country_code_3
      )[0];
      if (country_obj) {
        let r_obj = country_obj.regions.filter(
          (ele) => ele.region.id == row.key
        )[0];
        if (!r_obj) {
          // Delivery Modifier code starts here
          if (this.stepInput.isDlvMod) {
            const isRegionIncluded = this.geoObject.some((geo) =>
              geo.regions.some((region) => region.region_included == true)
            );
            if (isRegionIncluded) {
              let added = false;
              // If incoming region's country matches with existing country object.
              if (country_obj) {
                this.geoObject = this.geoObject.filter((geo) => {
                  // If region is present and matches with country id =, replace it with incoming region.
                  if (geo.country.id == country_obj.country.id) {
                    if (geo.regions.length == 0) {
                      added = true;
                      geo.regions = [region_obj];
                    } else {
                      geo.regions.forEach((region) => {
                        if (region.region_included) {
                          if (region.cities.length == 0) {
                            added = true;
                            region.region = region_obj.region;
                          } else {
                            added = true;
                            region.region_included = false;
                            geo.regions.push(region_obj);
                          }
                          return true;
                        }
                      });
                    }
                    return true;
                  } else {
                    // If incoming region's country is different with the existing one
                    if (
                      geo.regions.some(
                        (region) =>
                          region.region_included || region.cities.length != 0
                      )
                    ) {
                      geo.regions = geo.regions.filter((region) => {
                        //if city is present and region is included, set region to false;
                        if (
                          region.region_included &&
                          region.cities.length != 0
                        ) {
                          region.region_included = false;
                          return true;
                        }
                        //if there is no city and region is included, remove the region;
                        else if (region.region_included) {
                          return false;
                        } else {
                          return true;
                        }
                      });
                      return geo.country_included || geo.regions.length != 0;
                    } else {
                      return false;
                    }
                  }
                });
                if (!added) {
                  country_obj.regions.push(region_obj);
                }
              } else {
                this.geoObject.forEach((geo) => {
                  geo.regions.forEach((region, index) => {
                    if (region.region_included) {
                      geo.regions[index] = region_obj;
                      geo.country = {
                        id: row.country_code_3,
                        name: row.country_name,
                      };
                    }
                  });
                });
              }
            } else {
              country_obj.regions.push(region_obj);
            }
          }
          // Delivery Modifier code ends

          // LI-Geo Targeting code
          else {
            country_obj.regions.push(region_obj);
          }
          this.region_action = action;
        } else {
          if (action == "exclude") {
            let dont_allow_save: boolean = false;
            if (r_obj.cities.length > 0 && this.city_action == "include") {
              dont_allow_save = true;
            }
            if (!dont_allow_save) {
              r_obj.region_included = true;
              this.region_action = action;
            }
          } else {
            if (this.stepInput.isDlvMod && !r_obj.region_included) {
              this.geoObject = this.geoObject.filter((geo) => {
                if (geo.country.id != country_obj.country.id) {
                  return false;
                }
                geo.regions = geo.regions.filter((region) => {
                  return region.region.id == r_obj.region.id;
                });
                return true;
              });
            }
            r_obj.region_included = true;
            this.region_action = action;
          }
        }
      } else {
        // Delivery Modifier code starts
        if (this.stepInput.isDlvMod) {
          const isRegionIncluded = this.geoObject.some((geo) =>
            geo.regions.some((region) => region.region_included == true)
          );
          let added = false;
          if (isRegionIncluded) {
            this.geoObject.forEach((geo) => {
              geo.regions = geo.regions.filter((region) => {
                if (region.region_included) {
                  if (region.cities.length == 0 && geo.regions.length == 1) {
                    added = true;
                    region.region = {
                      id: region_obj.region.id,
                      name: region_obj.region.name,
                    };
                    region.region_included = true;
                    geo.country = {
                      id: row.country_code_3,
                      name: row.country_name,
                    };
                    return true;
                  } else {
                    region.region_included = false;
                    return region.cities.length != 0;
                  }
                } else {
                  return true;
                }
              });
            });
          }
          if (!added) {
            this.geoObject.push({
              country: { id: row.country_code_3, name: row.country_name },
              country_included: false,
              regions: [region_obj],
            });
          }
        }
        // Delivery Modifier code ends

        // LI-Geo Targeting
        else {
          this.geoObject.push({
            country: { id: row.country_code_3, name: row.country_name },
            country_included: false,
            regions: [region_obj],
          });
        }
        this.region_action = action;
      }
    } else if (
      this.selectedGeoTab == "city" &&
      (this.city_action == "" || this.city_action == action)
    ) {
      this.city_action = action;
      let country_obj = this.geoObject.filter(
        (ele) => ele.country.id == row.country_code_3
      )[0];
      if (country_obj) {
        let region_obj = country_obj.regions.filter(
          (ele) => ele.region.id == row.country_code_3 + "/" + row.region_code
        )[0];
        if (region_obj) {
          if (!region_obj.cities.filter((ele) => ele.id == row.geoname)[0]) {
            // Delivery Modifier code starts
            if (this.stepInput.isDlvMod) {
              region_obj.cities = [{ id: row.geoname, name: row.name }];
              if (
                country_obj.regions.length > 1 &&
                region_obj.region_included
              ) {
                country_obj.regions = country_obj.regions.filter(
                  (ele) =>
                    ele.region.id == row.country_code_3 + "/" + row.region_code
                );
              }
              if (this.geoObject.length > 1) {
                this.geoObject.forEach((geo, index) => {
                  geo.regions.forEach((region, reg_obj) => {
                    if (region.region_included) {
                      if (geo.country.id == country_obj.country.id) {
                        region.cities = [{ id: row.geoname, name: row.name }];
                      } else {
                        region.cities.length == 0;
                      }
                    } else {
                      if (
                        geo.country.id != country_obj.country.id &&
                        !geo.country_included
                      ) {
                        this.geoObject.splice(index, 1);
                      }
                    }
                  });
                });
              }
            }
            // Delivery Modifier code ends

            //Li-Geo targeting code
            else {
              region_obj.cities.push({ id: row.geoname, name: row.name });
            }
          }
        } else {
          // if the existing region id does not match the region id of incoming city
          // Delivery Modifier code starts
          if (this.stepInput.isDlvMod) {
            this.geoObject.forEach((geo, index) => {
              //
              if (geo.regions.length != 0) {
                geo.regions.forEach((region, i) => {
                  // If region_include is false
                  if (!region.region_included) {
                    // and if country id matches,update the region
                    // object directly (no need to use index)
                    if (geo.country.id == country_obj.country.id) {
                      region.region = {
                        id: row.country_code_3 + "/" + row.region_code,
                        name: row.region_name,
                      }; // Set the region id and name
                      region.cities = [{ id: row.geoname, name: row.name }]; // Set the cities array
                    } else {
                      if (region.cities.length == 0) {
                        geo.regions.push({
                          region: {
                            id: row.country_code_3 + "/" + row.region_code,
                            name: row.region_name,
                          },
                          region_included: false,
                          cities: [{ id: row.geoname, name: row.name }],
                        });
                      }
                      this.geoObject.splice(index, 1);
                    }
                  } else {
                    if (region.region_included) {
                      // remove the city.
                      if (region.cities.length != 0) {
                        region.cities.length = 0;
                      }
                      if (geo.country.id == country_obj.country.id) {
                        geo.regions.push({
                          region: {
                            id: row.country_code_3 + "/" + row.region_code,
                            name: row.region_name,
                          },
                          region_included: false,
                          cities: [{ id: row.geoname, name: row.name }],
                        });
                      }
                    }
                  }
                });
              } else {
                country_obj.regions = [
                  {
                    region: {
                      id: row.country_code_3 + "/" + row.region_code,
                      name: row.region_name,
                    },
                    region_included: false,
                    cities: [{ id: row.geoname, name: row.name }],
                  },
                ];
              }
            });
          }
          // Delivery Modifier code ends

          // LI-Geo Targeting code
          else {
            country_obj.regions.push({
              region: {
                id: row.country_code_3 + "/" + row.region_code,
                name: row.region_name,
              },
              region_included: false,
              cities: [{ id: row.geoname, name: row.name }],
            });
          }
        }
      } else {
        // Delivery Modifier code starts

        if (this.stepInput.isDlvMod) {
          if (this.geoObject.length != 0) {
            let added = false;
            this.geoObject.forEach((geo, index) => {
              geo.regions.forEach((region, reg_index) => {
                if (!region.region_included) {
                  if (row.country_code_3 == geo.country.id) {
                    added = true;
                    geo[index].country = {
                      id: row.country_code_3,
                      name: row.country_name,
                    };
                    region[reg_index].region = {
                      id: row.country_code_3 + "/" + row.region_code,
                      name: row.region_name,
                    };
                    region[reg_index].cities = [
                      { id: row.geoname, name: row.name },
                    ];
                  } else {
                    geo.regions.length == 1
                      ? this.geoObject.splice(index, 1)
                      : geo.regions.splice(reg_index, 1);
                  }
                } else {
                  if (geo.country.id != row.country_code_3) {
                    region.cities.length = 0;
                  }
                }
              });
            });
            if (!added) {
              this.geoObject.push({
                country: { id: row.country_code_3, name: row.country_name },
                country_included: false,
                regions: [
                  {
                    region: {
                      id: row.country_code_3 + "/" + row.region_code,
                      name: row.region_name,
                    },
                    region_included: false,
                    cities: [{ id: row.geoname, name: row.name }],
                  },
                ],
              });
            }
          } else {
            this.geoObject.push({
              country: { id: row.country_code_3, name: row.country_name },
              country_included: false,
              regions: [
                {
                  region: {
                    id: row.country_code_3 + "/" + row.region_code,
                    name: row.region_name,
                  },
                  region_included: false,
                  cities: [{ id: row.geoname, name: row.name }],
                },
              ],
            });
          }
        }
        // Delivery Modifier code ends

        // LI-Geo Targeting code
        else {
          this.geoObject.push({
            country: { id: row.country_code_3, name: row.country_name },
            country_included: false,
            regions: [
              {
                region: {
                  id: row.country_code_3 + "/" + row.region_code,
                  name: row.region_name,
                },
                region_included: false,
                cities: [{ id: row.geoname, name: row.name }],
              },
            ],
          });
        }
      }
    }
    this.checkForUS();
    this.proceed();
  }

  removeCountry(index) {
    this.geoObject.splice(index, 1);
    let reset_country_action: boolean = true;
    if (this.geoObject.length == 0) {
      this.region_action = "";
      this.city_action = "";
      if (
        !this.stepInput.isBulkEdit ||
        (this.stepInput.isBulkEdit && this.stepInput.areCtryTargetsEmpty)
      )
        this.country_action = "";
    }
    this.geoObject.forEach((c) => {
      if (c.country_included) {
        reset_country_action = false;
      }
    });
    if (
      reset_country_action &&
      (!this.stepInput.isBulkEdit ||
        (this.stepInput.isBulkEdit && this.stepInput.areCtryTargetsEmpty))
    ) {
      this.country_action = "";
    }
    this.checkForUS();
    this.proceed();
  }

  removeRegion(country_index, region_index) {
    this.geoObject[country_index].regions.splice(region_index, 1);
    if (
      !this.geoObject[country_index].country_included &&
      this.geoObject[country_index].regions.length == 0
    ) {
      this.removeCountry(country_index);
    }
    let regions = [];
    let cities = [];
    this.geoObject.forEach((country) => {
      country.regions.forEach((reg) => {
        if (reg.region_included) {
          regions.push(reg.region);
        }
        cities = cities.concat(reg.cities);
      });
    });
    if (regions.length == 0) {
      this.region_action = "";
    }
    if (cities.length == 0) {
      this.city_action = "";
    }
    this.proceed();
  }

  removeCity(country_index, region_index, city_index) {
    this.geoObject[country_index].regions[region_index].cities.splice(
      city_index,
      1
    );
    if (
      !this.geoObject[country_index].regions[region_index].region_included &&
      this.geoObject[country_index].regions[region_index].cities.length == 0
    ) {
      this.removeRegion(country_index, region_index);
    }
    let cities = [];
    this.geoObject.forEach((country) => {
      country.regions.forEach((region) => {
        cities = cities.concat(region.cities);
      });
    });
    if (cities.length == 0) {
      this.city_action = "";
    }
    this.proceed();
  }

  removeAllGeo() {
    this.geoObject.splice(0, this.geoObject.length);
    this.region_action = "";
    this.city_action = "";
    if (
      !this.stepInput.isBulkEdit ||
      (this.stepInput.isBulkEdit && this.stepInput.areCtryTargetsEmpty)
    )
      this.country_action = "";
    this.checkForUS();
    this.proceed();
  }

  searchDma(event) {
    let filter = event.target.value.toLowerCase();
    let isCode = Number.isFinite(parseInt(filter));
    let params;
    if (isCode && filter.length >= 3) {
      params = {
        fields: "key",
        key: filter,
      };
      this.getAllDma(params);
    }
    if (!isCode) {
      params = {
        fields: "name",
        name: filter,
      };
      this.getAllDma(params);
    }
  }

  removeAllDma() {
    this.selectedMetro = [];
    this.metro_action = "";
    this.proceed();
  }

  addDma(item, action) {
    if (
      (this.metro_action == "" || this.metro_action == action) &&
      !this.selectedMetro.filter((e) => e.key == item.key)[0]
    ) {
      this.selectedMetro.push(item);
      this.metro_action = action;
    }
    this.proceed();
  }

  removeDma(item) {
    this.selectedMetro = this.selectedMetro.filter((e) => e.key !== item.key);
    this.selectedMetro.length == 0
      ? (this.metro_action = "")
      : this.metro_action;
    this.proceed();
  }

  clearAllTextFromPostalTextArea() {
    this.inputZipCodes = null;
  }

  getInputOfIds(id: string) {
    let separatedIds = id
      .split(/[,|\n]/)
      .map((e) => e.trim())
      .filter((e) => e != "");
    return separatedIds;
  }

  addPostalCodes() {
    if (this.inputZipCodes) {
      let postalCodes = new Set(this.getInputOfIds(this.inputZipCodes));
      let unique_postalCodes = Array.from(postalCodes);
      this.selectedZip = [...unique_postalCodes, ...this.selectedZip];
      this.selectedZip = this.commonService.getDistinctArray(this.selectedZip);
      this.inputZipCodes = null;
      this.proceed();
    }
  }

  avlCtryForTar() {
    this.commonService.displayAvlCountry(this.ctryToTarget);
  }

  removeAllPostalCodes() {
    this.selectedZip = [];
    this.proceed();
  }

  removeSelectedPostalCodes(index) {
    this.selectedZip.splice(index, 1);
    this.proceed();
  }

  updatePostalCodeAction(type) {
    this.zip_action = type;
    this.proceed();
  }

  checkOperation(type, value = null) {
    if (type === "country") {
      this.bulkEditTrgtAct["region"] = value;
      this.bulkEditTrgtAct["city"] = value;
    }
    switch (type) {
      case "country":
        if (this.bulkEditTrgtAct.country == "remove_all") {
          this.removeAllGeo();
        }
        break;
      case "zip":
        if (this.bulkEditTrgtAct.zip == "remove_all") {
          this.removeAllPostalCodes();
        }
        break;
    }
  }

  proceed() {
    let obj = {
      country_action: this.country_action,
      region_action: this.region_action,
      city_action: this.city_action,
      geoObject: this.geoObject,
      zip_action: this.zip_action,
      metro_action: this.metro_action,
      selectedMetro: this.selectedMetro,
      selectedZip: this.selectedZip,
      customLocs: this.customLocs,
    };
    this.commonService.setGeographyData(obj);
  }
}
